import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  list: [],
  item: null,
};

const zpCVysledokVyjadrenia = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_ZP_C_VYSLEDOK_VYJADRENIA_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_ZP_C_VYSLEDOK_VYJADRENIA_SUCCESS:
      return { ...state, isLoading: false, list: action.res.Data };

    case actionTypes.GET_ZP_C_VYSLEDOK_VYJADRENIA_FAILURE:
      return _initState;

    case actionTypes.CHANGE_VYSLEDOK_VYJADRENIA:
      return { ...state, item: action.data };

    default:
      return state;
  }
};

export default zpCVysledokVyjadrenia;
